import SectionRecord from "models/view-models/section-record";
import { useMultipleSectionPreviews } from "organisms/checklist-item-notes/hooks/use-multiple-section-previews";
import { UseSectionPreviewValue } from "organisms/checklist-item-notes/hooks/use-section-preview-value";
import { useSingleSectionPreview } from "organisms/checklist-item-notes/hooks/use-single-section-preview";

export const useSectionPreview = (
    availableSections: SectionRecord[],
    enableMultiplePreview: boolean
): UseSectionPreviewValue => {
    const singleSectionPreview = useSingleSectionPreview(availableSections);
    const multipleSectionPreview =
        useMultipleSectionPreviews(availableSections);

    return enableMultiplePreview
        ? multipleSectionPreview
        : singleSectionPreview;
};
